export default {"src":"/uk/_next/static/media/pwResetIcon.620b8509.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};